<template>
  <MotionSlider :testimonials="testimonials" title="Operator Success" />
</template>

<script setup lang="ts">
  import { esmail, mohammad } from '@/assets/images';
  import MotionSlider from './MotionSlider.vue';

  const testimonials = [
    {
      quote:
        'The zero upfront cost model from Cashflow Casino saved our operation. We were able to launch without worrying about initial bankroll, and the weekly settlements make cash flow management a breeze.',
      author: 'Marcus J.',
      role: 'Managing Director',
      company: 'VegasPeak',
      profile: mohammad,
    },
    {
      quote:
        'Integrating their Loyalty Engine has been a game changer for our retention metrics. Player LTV has increased by 40% in just three months. Truly impressive tech.',
      author: 'Sarah L.',
      role: 'Head of Growth',
      company: 'AceSlots',
      profile: esmail,
    },
  ];
</script>
